import React, { useState } from "react";
import PropTypes from "prop-types";
import { validateInput } from "../../utilities/Validator";

const RadioInput = ({
  onChange,
  label,
  inputClass,
  checked,
  value,
  name,
  labelClass,
  validators,
  disabled,
  getError,
  required,
  id,
  labelStyle,
}) => {
  const [error, setError] = useState(false);

  const handleChange = (val) => {
    setError(validateInput(validators, val));
    onChange(val);
    getError &&
      getError(
        validateInput(validators, val) ? validateInput(validators, val) : false
      );
  };
  return (
    <>
      <div className="library-radio">
        <input
          type="radio"
          id={id || name}
          name={name}
          value={value}
          onChange={(e) => handleChange(e.target.value)}
          checked={checked}
          className={inputClass}
          disabled={disabled}
        />
        <label
          className={`${labelClass} radio-label`}
          htmlFor={id}
          style={{ opacity: 1, ...labelStyle }}
          onChange={(e) => handleChange(e.target.value)}
        >
          {label}
          {required ? <b className={"text-danger"}> *</b> : ""}
        </label>
        {error && <span className="text-danger errormsg">{error.message}</span>}
      </div>
    </>
  );
};
RadioInput.prototype = {
  disabled: PropTypes.bool,
  value: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  validators: PropTypes.array,
  type: PropTypes.string,
  onchange: PropTypes.func.isRequired,
  labelClass: PropTypes.string,
  inputClass: PropTypes.string,
  checked: PropTypes.bool,
  labelClass: PropTypes.object,
};

RadioInput.defaultProps = {
  value: "",
  label: "",
  placeholder: "",
  type: "radio",
  labelClass: "col-md-6",
  inputClass: "col-md-6",
  id: "",
  validators: [],
  disabled: false,
  labelStyle: {},
};
export default RadioInput;
